// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ebe8da5c","389":"94be7c17","455":"21cdf916","857":"2bc0a3f5","977":"27229745"}[chunkId] + ".chunk.js";
};